/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreExternalCostResponseDto } from '../../models/core-external-cost-response-dto';

export interface ExternalCostsControllerFindBySubtaskId$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Subtask identifier
 */
  subtaskId: string;
}

export function externalCostsControllerFindBySubtaskId(http: HttpClient, rootUrl: string, params: ExternalCostsControllerFindBySubtaskId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, externalCostsControllerFindBySubtaskId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('subtaskId', params.subtaskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreExternalCostResponseDto>>;
    })
  );
}

externalCostsControllerFindBySubtaskId.PATH = '/o2-core/external-costs/{tenant}/subtask/{subtaskId}';
